import { openClickLogDebugToast } from '@web/libs/dev/clickCodeDebugMode.state'
import { NClickLogEvent } from '@web/types/browser'

import { extractErrorMessage, neloLogger } from '../../utils'

export interface ClickLog {
  element?: Element | null
  event?: NClickLogEvent | null
  area: string
  rank?: string | number | null
  contentId?: string | number | null
  contentType?: string | null
  reviewId?: string | null
  visitId?: string | null
  placeId?: string | null
  businessId?: string | null
}

/**
 * @trigger http://ntm.navercorp.com/containers/my-place-web/triggers/custom-event-9a2084b8-c9e1-4886-a9f2-f999932a3fcb
 * @tag http://ntm.navercorp.com/containers/my-place-web/tags/nlog-0675483e-b177-47c7-b7a8-03c9dea22805
 * @param log
 * @returns
 */
const sendClickLog = (clickLog: ClickLog) => {
  try {
    if (!window.ntm) return

    if (!clickLog.area || clickLog.area === '') return

    openClickLogDebugToast(clickLog)

    const { contentId, contentType, placeId, reviewId, visitId, businessId } = clickLog

    const mapplace = contentId && contentType ? { content_id: contentId, content_type: contentType } : undefined
    const myplace =
      reviewId || placeId || visitId || businessId
        ? { review_id: reviewId, place_id: placeId, visit_id: visitId, business_id: businessId }
        : undefined

    const logData = {
      click_element: clickLog.element ?? clickLog.event?.currentTarget,
      click_event: clickLog.event,
      click_area: clickLog.area,
      click_rank: clickLog.rank,
      click_cid: clickLog.contentId,
      nlogEvt: {
        mapplace,
        myplace,
      },
    }

    window.ntm.push({ event: 'sendClick', ...logData })
  } catch (error) {
    neloLogger('error', `sendClickLog ${extractErrorMessage(error)}`)
    return
  }
}

export default sendClickLog
